/* Plot & Harvest optional add-ons (4-10-2026).
   Moves the add-on box into the product buy form; once ph-product.js has put the main item in the basket
   (it fires cart:update with sourceId 'ph-pdp'), the chosen add-ons are added as their own lines. */
(function () {
  'use strict';
  function $(s, el) { return (el || document).querySelector(s); }
  function $$(s, el) { return Array.prototype.slice.call((el || document).querySelectorAll(s)); }
  var box = $('[data-addons]');
  var form = $('[data-ph-pdp] [data-buy-form]');
  if (!box || !form || !window.fetch) return;
  var row = $('.ph-buy__row', form);
  form.insertBefore(box, row || null);
  box.hidden = false;
  var src = $('[data-ph-addons-src]'); if (src && !src.children.length) src.hidden = true;

  var CUR = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'GBP';
  function money(c) { try { return new Intl.NumberFormat('en-GB', { style: 'currency', currency: CUR }).format(c / 100); } catch (e) { return '£' + (c / 100).toFixed(2); } }
  var sum = $('[data-addons-sum]', box), forT = box.getAttribute('data-for') || '', busy = false;

  function clamp(inp) { var n = parseInt(inp.value, 10); n = isNaN(n) ? 0 : Math.min(99, Math.max(0, n)); inp.value = n; return n; }
  function picked() {
    return $$('[data-addon]', box).map(function (r) {
      var inp = $('[data-addon-qty]', r);
      return { id: +r.getAttribute('data-addon'), quantity: inp ? clamp(inp) : 0, price: +r.getAttribute('data-price') || 0 };
    }).filter(function (x) { return x.quantity > 0; });
  }
  function refresh() {
    var t = 0, n = 0;
    picked().forEach(function (x) { t += x.price * x.quantity; n += x.quantity; });
    $$('[data-addon]', box).forEach(function (r) { var inp = $('[data-addon-qty]', r); r.classList.toggle('is-on', !!inp && +inp.value > 0); });
    sum.hidden = !n;
    sum.textContent = n ? n + ' add-on' + (n > 1 ? 's' : '') + ' selected: ' + money(t) + ' extra' : '';
  }
  $$('[data-addon-step]', box).forEach(function (b) {
    b.addEventListener('click', function () {
      var inp = $('[data-addon-qty]', b.parentNode);
      inp.value = (parseInt(inp.value, 10) || 0) + +b.getAttribute('data-addon-step'); clamp(inp); refresh();
    });
  });
  $$('[data-addon-qty]', box).forEach(function (inp) {
    inp.addEventListener('change', function () { clamp(inp); refresh(); });
    inp.addEventListener('keydown', function (e) { if (e.key === 'Enter') { e.preventDefault(); clamp(inp); refresh(); } });
  });

  document.addEventListener('cart:update', function (e) {
    var d = e.detail || {};
    if (d.sourceId !== 'ph-pdp' || busy) return;
    var items = picked();
    if (!items.length) return;
    busy = true;
    var base = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    var msg = $('[data-buy-msg]', form.closest('[data-ph-pdp]') || document);
    var n = items.reduce(function (s, x) { return s + x.quantity; }, 0);
    fetch(base + 'cart/add.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: items.map(function (x) { return { id: x.id, quantity: x.quantity, properties: { 'Add-on for': forT } }; }) })
    })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); })
      .then(function () { return fetch(base + 'cart.js').then(function (r) { return r.json(); }); })
      .then(function (cart) {
        $$('[data-addon-qty]', box).forEach(function (inp) { inp.value = 0; }); refresh();
        if (msg) {
          var link = $('a', msg), txt = 'Added to your basket with ' + n + ' add-on' + (n > 1 ? 's' : '') + '. ';
          msg.textContent = txt; if (link) msg.appendChild(link);
        }
        document.dispatchEvent(new CustomEvent('cart:update', { bubbles: true, detail: { resource: cart, sourceId: 'ph-addons', data: { itemCount: cart.item_count, source: 'ph-addons' } } }));
      })
      .catch(function (err) {
        if (msg) { msg.hidden = false; msg.className = 'ph-buy__msg is-err'; msg.textContent = 'Your item was added, but the add-ons were not: ' + ((err && (err.description || err.message)) || 'please try again') + '.'; }
      })
      .then(function () { busy = false; });
  });
})();
